import jbAPI from "./jobboard";

export const saveJob = async (job_id, job_seeker_id, token) => {
  try {
    const response = await jbAPI.post(
      `/jobs/${job_id}/save`,
      { job_seeker_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to save job:", error);
    throw error;
  }
};

export const getSavedJobs = async (job_seeker_id, token) => {
  try {
    const response = await jbAPI.get(`/jobs/saved/${job_seeker_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.savedJobIds;
  } catch (error) {
    console.error("Failed to fetch saved jobs:", error);
    return [];
  }
};

export const getSavedJobsbyJSId = async (job_seeker_id, token) => {
  try {
    const response = await jbAPI.get(`/saved-jobs/${job_seeker_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch saved jobs:", error);
    return [];
  }
};


export const removeSavedJob = async (job_seeker_id, job_id, token) => {
  try {
    const response = await jbAPI.delete(`/jobs/saved/${job_seeker_id}/${job_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // { success: true, message: ... }
  } catch (error) {
    console.error("Failed to remove saved job:", error);
    return { success: false };
  }
};
